// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"3ff78a63","538":"2c972985"}[chunkId] + ".chunk.css";
};